import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

const RESUMPTION_AVAILABLE_GATE = 'rovo_chat_use_resumption_available';

export const shouldUseResumption = (action: MessageAction): boolean =>
	fg(RESUMPTION_AVAILABLE_GATE) ? action.resumptionAvailable === true : Boolean(action.toolSource);

export const resolveResumptionEligibility = (actions: MessageAction[]): boolean =>
	actions.length > 0 && actions.every(shouldUseResumption);
